import styled from 'styled-components';
import Input from 'components/ui/Input';
import Label from 'components/ui/Label';

import { colours } from 'themes/default';

export const StyledManageVoucherContainer = styled.div`
  max-width: 1024px;
  min-width: 60%;
  margin: auto;
  padding: 25px;
`;

export const StyledSearchByHeader = styled.h4`
  margin-left: 10px;
`;

export const StyledSearchSuggestionsList = styled.ul`
  padding: 0;
  list-style-position: inside;
  margin-bottom: 30px;
`;

export const StyledForm = styled.form`
  background-color: ${colours.Shades.TintBlue10};
  padding: 10px;
  margin-bottom: 10px;
`;

export const StyledInput = styled(Input)`
  line-height: 1;
  box-sizing: border-box;
`;

export const StyledSubmitField = styled.div`
  text-align: right;
  display: inline-block;
  width: 30%;
`;

export const MandatoryFieldLabel = styled(Label)`
  &::after {
    content: ' *';
    color: red;
  }
`;

export const Field = styled.div`
  margin: 0.4em 0;
  width: 70%;
  display: inline-block;
`;
export const ErrorField = styled.div`
  color: red;
`;
